module.exports = __webpack_public_path__ + "img/40_69_004_820.368df913.jpg";